import { createSlice } from '@reduxjs/toolkit';
import { Card } from '../../models/Card';

interface TooltipState {
  isVisible: boolean;
  card: Card | null,
  cards: Card[],
  isPlayerTooltipVisible: boolean;
}

const initialState: TooltipState = {
  isVisible: false,
  card: null,
  cards: [],
  isPlayerTooltipVisible: false,
}

const tooltipSlice = createSlice({
  name: 'tooltip',
  initialState,
  reducers: {
    show: ((state, data) => {
      state.isVisible = true;
      state.card = data.payload.card;
      state.cards = data.payload.cards;
    }),
    hide: ((state) => {
      state.isVisible = false;
      state.card = null;
    }),
    togglePlayerTooltip: ((state) => {
      state.isPlayerTooltipVisible = !state.isPlayerTooltipVisible;
    }),
  },
});

export const tooltipActions = tooltipSlice.actions;
export default tooltipSlice.reducer;